import loadScript from 'modules/load-script'; // from promise based script loader
import { encodeData } from 'utils/helper';

const CALLBACK_NAME = '__googleMapsApiOnLoadCallback';
const API_BASE = 'https://maps.googleapis.com/maps/api/js';
const PARAMS_KEYS = ['client', 'key', 'language', 'v'];

/**
 * Options:
 * timeout: time in milliseconds before rejecting the promise
 * client: Client ID
 * key: Your API Key
 * language: Language
 * v: API version
 */

const loadGoogleMapsApi = opt => {
  const options = opt || {};
  // Check whether API is already loaded
  if (window.google && window.google.maps) {
    return Promise.resolve(window.google.maps);
  }
  return new Promise((resolve, reject) => {
    // Reject the promise after a timeout
    const timeoutId = window.setTimeout(() => {
      window[CALLBACK_NAME] = () => {};
      reject(
        new Error(
          `Timeout: Could not load Google Maps API in ${
            options.timeout || 10000
          }ms`
        )
      );
    }, options.timeout || 10000);
    // Insert on load callback
    window[CALLBACK_NAME] = () => {
      if (timeoutId !== null) {
        window.clearTimeout(timeoutId);
      }
      resolve(window.google.maps);
      delete window[CALLBACK_NAME];
    };
    // build params
    const paramsObj = PARAMS_KEYS.filter(key => options[key]).reduce(
      (o, key) => Object.assign(o, { [key]: options[key] }),
      {}
    );
    const params = encodeData(paramsObj);
    loadScript(`${API_BASE}?${params}&callback=${CALLBACK_NAME}`, error => {
      if (error) {
        reject(
          new Error(
            `Could not load ${API_BASE}?${params}&callback=${CALLBACK_NAME}`
          )
        );
      }
    });
  });
};

export default loadGoogleMapsApi;
